import React, { Component } from "react";
//import axios from 'axios';
//import moment from 'moment';
import SearchMessages from "../elements/SearchMessages";
import Person from "../elements/Person";
import List from "../elements/List";
import TableSort from "../elements/form/TableSort";
import { spinnerService } from "../../service/SpinnerService";
import PropTypes from "prop-types";
import classNames from "classnames";

import factory from "../../api/factory";
import db from "../../api/db";

class Search extends Component {
  static propTypes = {
    params: PropTypes.array
  };

  constructor(props) {
    super(props);
    this.state = {
      age: "",
      persons: [],
      activerow: "",
      selected: [],
      checkall: false,
      params: this.props.Params,
      listworking: false,
      working: true,
      count: 0,
      sort: "_score",
      sortDirection: "desc",
      clientcodes: [],
      loadedPersons: {},
      editmode: false,
      listName: "",
      inList: [],
      size: 40,
      from: 0
    };

    this.setActiveRow = this.setActiveRow.bind(this);
    this.setSort = this.setSort.bind(this);
    this.selectedPersons = this.selectedPersons.bind(this);
    this.list = React.createRef();
    this.dispatchPayload = this.dispatchPayload.bind(this);

    this.listStatus = this.listStatus.bind(this);

    this.setListPersons = this.setListPersons.bind(this);
    this.setEditList = this.setEditList.bind(this);
    this.exitEditMode = this.exitEditMode.bind(this);

    this.nextPage = this.nextPage.bind(this);
    this.prevPage = this.prevPage.bind(this);
  }

  componentDidMount() {
    if (
      (this.state.params && this.state.params.length) ||
      (this.props.location.state && this.props.location.state.params)
    ) {
      const params = this.state.params.length
        ? this.state.params
        : this.props.location.state.params;
      this.searchQuery(params);
    }
  }

  componentWillReceiveProps(props) {
    if (
      JSON.stringify(this.props.Params) !== JSON.stringify(props.Params) &&
      this.state.editmode
    ) {
      this.exitEditMode();
    } else {
      this.setState(
        {
          params: props.Params
        },
        () => {
          if (!this.listMode()) {
            this.setState({
              persons: [],
              from: 0,
              count: 0,
              sort: "_score",
              sortDirection: "desc"
            });
          }
          this.searchQuery(props.Params);
        }
      );
    }
  }

  searchQuery(params = this.state.params) {
    this.setState(
      {
        loadedPersons: 0,
        selected: [],
        activerow: "",
        from: 0,
        size: 40,
        persons: [],
        count: 0,
        sort: "_score",
        sortDirection: "desc"
      },
      () => {
        spinnerService.show("indeterminate");

        if (!this.listMode() && params["string"].length) {
          factory.freetext(params["string"]).then(response => {
            this.searchDB(params);
          });
        } else {
          this.searchDB(params);
        }
      }
    );
  }

  searchDB(params = this.state.params) {
    if (!params.session_operation) {
      this.setState({
        working: false
      });
      spinnerService.hide("indeterminate");
      return;
    }

    const sort = this.state.sort;
    var sortorder = {};
    sortorder[sort] = {
      order: this.state.sortDirection
    };

    const query = db.prepPersonQuery(params, sortorder);

    query["pagination"] = {
      size: this.state.size,
      from: this.state.from
    };

    db.query("person", query)
      .then(response => {
        spinnerService.hide("indeterminate");
        if (response.data.hits) {
          this.setState({
            persons: response.data.hits,
            count: response.data.total,
            working: false
          });
        } else {
          this.setState({
            persons: [],
            count: 0,
            working: false
          });
        }
      })
      .catch(err => {
        spinnerService.hide("indeterminate");
        console.log(err);
        this.setState({
          persons: [],
          count: 0,
          working: false
        });
      });
  }

  searchFactory(params = this.state.params) {
    this.setState({ persons: [] });

    factory.freetext(params["string"]).then(response => {
      this.setState({
        persons: response.data,
        count: response.data.length,
        working: false
      });
      spinnerService.hide("indeterminate");
    });
  }

  updateResults(persons) {
    this.setState({
      persons: persons
    });
  }

  setActiveRow(id) {
    if (id === this.state.activerow) {
      this.setState({
        activerow: ""
      });
    } else {
      this.setState({
        activerow: id
      });
    }
  }

  setSort(e) {
    spinnerService.show("indeterminate");
    let sort = e.target.getAttribute("data-value");
    const el = e.target.getAttribute("data-el");

    let direction = this.state.sortDirection;

    if (el === "sort" && sort === this.state.sort) {
      sort = "_score";
      direction = "desc";
    }

    if (el === "direction") {
      if (this.state.sortDirection === "asc") {
        direction = "desc";
      } else {
        direction = "asc";
      }
    }

    this.setState(
      {
        sort: sort,
        sortDirection: direction
      },
      () => {
        this.searchDB();
      }
    );
  }

  nextPage() {
    spinnerService.show("indeterminate");
    this.setState(
      prevState => {
        return { from: prevState.from + this.state.size, persons: [] };
      },
      () => {
        this.searchDB();
        window.scrollTo(0, 0);
      }
    );
  }

  prevPage() {
    spinnerService.show("indeterminate");
    this.setState(
      prevState => {
        return { from: prevState.from - this.state.size, persons: [] };
      },
      () => {
        this.searchDB();
        window.scrollTo(0, 0);
      }
    );
  }

  currentPage() {
    const from = this.state.from;
    const size = this.state.size;
    return from ? from / size + 1 : 1;
  }

  totalPages() {
    const total = this.state.count;
    const size = this.state.size;
    const pages = Math.ceil(total / size);
    return pages ? pages : 1;
  }

  selectedPersons(id) {
    let selected = this.state.selected;
    let index;
    let checkall = false;

    if (selected.indexOf(id) > -1) {
      index = selected.indexOf(id);
      selected.splice(index, 1);
    } else {
      selected.push(id);
    }

    if (selected.length === this.state.persons.length) {
      checkall = true;
    }

    this.setState({
      selected: selected,
      checkall: checkall
    });
  }

  checkallPersons(event = {}) {
    if (this.state.checkall) {
      this.setState({
        checkall: false,
        selected: []
      });
    } else {
      let selected = [];
      this.state.persons.map((item, i) => {
        if (
          item.code !== 5 &&
          !item.nomention &&
          this.state.inList.indexOf(item.id) < 0
        ) {
          return selected.push(item.id);
        } else {
          return "";
        }
      });

      this.setState({
        checkall: true,
        selected: selected
      });
    }
  }

  dispatchPayload() {
    if (this.state.selected.length) {
      let bootList = false;
      const selected = this.state.selected;

      if (this.state.editmode) {
        bootList = true;
        this.searchQuery();
      }

      this.setState(
        {
          editmode: false,
          checkall: false,
          selected: []
        },
        () => {
          this.list.current.receivePayload(selected, bootList);
        }
      );
    }
  }

  listStatus(status) {
    this.setState({
      listworking: status
    });
    if (status) {
      spinnerService.show("indeterminate");
    } else {
      spinnerService.hide("indeterminate");
    }
  }

  listMode() {
    if (this.state.params["session_operation"] !== "edit") {
      return true;
    } else {
      return false;
    }
  }

  setEditList(persons, list) {
    this.setState(
      {
        editmode: true,
        persons: persons,
        listName: list,
        inList: []
      },
      () => {
        this.checkallPersons();
      }
    );
    //this.props.disableHeader(true);
  }

  setListPersons(persons = []) {
    this.setState({
      inList: persons
    });
  }

  exitEditMode() {
    this.setState(
      {
        editmode: false,
        checkall: false,
        selected: []
      },
      () => {
        this.list.current.abortEdit();
        this.searchQuery();
        //this.props.disableHeader(false);
      }
    );
  }

  render() {
    let persons;

    if (this.state.count > 0) {
      persons = this.state.persons.map((item, i) => (
        <Person
          key={item.id}
          Person={item}
          Row={i % 2 ? "odd" : "even"}
          Active={item.id === this.state.activerow ? true : false}
          onChange={this.setActiveRow}
          selected={this.state.selected.indexOf(item.id) > -1 ? true : false}
          selectedPersons={this.selectedPersons}
          inList={this.state.inList.indexOf(item.id) > -1 ? true : false}
          selectBox={this.listMode()}
        />
      ));
    }

    return (
      <div className="main-container">
        <div className="grid-x">
          <div className="medium-9 cell">
            <div
              className={classNames("primary-content", "searchcontent", {
                editmode: this.state.editmode
              })}
            >
              <SearchMessages
                Display={this.listMode()}
                Date={this.state.params["session_date"]}
              />
              <div className="inner">
                <div className="grid-x align-justify">
                  <div className="cell small-3 align-self-bottom small-text">
                    {this.state.selected.length ? (
                      <div>{this.state.selected.length} markerte</div>
                    ) : (
                      ""
                    )}
                  </div>
                  <div className="cell small-6 main-header">
                    {this.state.editmode ? (
                      <span>Redigerer liste {this.state.listName}</span>
                    ) : (
                      <span>
                        Søkeresultat:{" "}
                        {Intl.NumberFormat().format(this.state.count)}{" "}
                        resultater viser {this.state.persons.length}, side{" "}
                        {this.currentPage()}/
                        {Intl.NumberFormat().format(this.totalPages())}
                      </span>
                    )}
                  </div>
                  <div className="cell small-3">
                    {this.state.editmode ? (
                      <button
                        onClick={this.exitEditMode}
                        className="button link top-button float-right"
                      >
                        Avbryt
                      </button>
                    ) : (
                      ""
                    )}
                    {this.listMode() ? (
                      <button
                        disabled={
                          this.state.listworking || !this.state.selected.length
                        }
                        onClick={this.dispatchPayload}
                        className="button top-button float-right"
                      >
                        {this.state.listworking
                          ? "Legger til ..."
                          : "Legg til i liste"}
                        <span className="icon"></span>
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
                <table
                  className={classNames("hover", "searchtable", {
                    working: this.state.working
                  })}
                >
                  <thead>
                    <tr>
                      <th>
                        {this.listMode() ? (
                          <div>
                            <input
                              id="check_top"
                              type="checkbox"
                              name="checkall"
                              checked={this.state.checkall}
                              onChange={e => this.checkallPersons(e)}
                            />
                            <label htmlFor="check_top"></label>
                          </div>
                        ) : (
                          ""
                        )}
                      </th>
                      <th>Fornavn</th>
                      <th>Etternavn</th>
                      <th>Adresse</th>
                      <th>Postnr.</th>
                      <th>Poststed</th>
                      <th>Født</th>
                      <TableSort
                        value="year"
                        label="Alder"
                        onChange={this.setSort}
                        sort={this.state.sort}
                        direction={this.state.sortDirection}
                      />
                      <TableSort
                        value="income"
                        label="Inntekt"
                        onChange={this.setSort}
                        sort={this.state.sort}
                        direction={this.state.sortDirection}
                      />
                      <TableSort
                        value="assets"
                        label="Formue"
                        onChange={this.setSort}
                        sort={this.state.sort}
                        direction={this.state.sortDirection}
                      />
                      <th>Bilde</th>
                      <th>Kategorier</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>{persons}</tbody>
                </table>
                {!this.state.editmode ? (
                  <div>
                    {this.state.from ? (
                      <button onClick={this.prevPage} className="button">
                        Forrige
                      </button>
                    ) : (
                      ""
                    )}
                    {this.currentPage() !== this.totalPages() ? (
                      <button
                        onClick={this.nextPage}
                        className="button float-right"
                      >
                        Neste
                      </button>
                    ) : (
                      ""
                    )}
                  </div>
                ) : (
                  ""
                )}
              </div>
            </div>
          </div>

          <div className="medium-3 cell">
            <div className="sidebar-holder">
              {this.listMode() &&
              this.state.params["session_operation"] &&
              this.state.params["session_date"] ? (
                <List
                  Status={this.listStatus}
                  ref={this.list}
                  Date={this.state.params["session_date"]}
                  Type={this.state.params["session_operation"]}
                  Client={this.state.params["client"]}
                  Setedit={this.setEditList}
                  Editmode={this.state.editmode}
                  setListPersons={this.setListPersons}
                />
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Search;
